import TableRow from "@mui/material/TableRow";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

import { TableCell } from "@mui/material";
import i18n from "../../../../i18n";
import isEmpty from "../../../helpers/isEmpty";
import { GroupedTableColumn } from "./GroupedTable";
import { TableGroupSearchToggle } from "./search/TableGroupSearchToggle";
import { GroupedTableSearchProps } from "./search/useGroupedTableSearch";
import { CheckboxPadded, TableCellFixedWidth } from "./styled";

interface Props {
  index?: number;
  columns: GroupedTableColumn[];
  translation: string;
  selectAll: (checkBoxSelected: boolean) => void;
  areAllSelected: boolean;
  disableSelectAllItems: boolean;
  disableSelectItems: boolean;
  search?: GroupedTableSearchProps;
  setOpen: () => void;
  open: boolean;
  hideAllCheckboxes?: boolean;
}

export const TableHeaderRow = ({
  index,
  columns,
  translation,
  selectAll,
  areAllSelected,
  disableSelectAllItems,
  disableSelectItems,
  setOpen,
  search,
  open,
  hideAllCheckboxes,
}: Props) => {
  const { t } = useTranslation(translation);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    selectAll(event.target.checked);
  };

  const UILanguage = i18n.language || "fi";

  const hideHeaderCheckbox = !isEmpty(search) || hideAllCheckboxes;

  return (
    <TableRow sx={{ position: "relative" }}>
      {!disableSelectAllItems && (
        <TableCellFixedWidth>
          {!hideHeaderCheckbox && (
            <CheckboxPadded
              checked={areAllSelected}
              onChange={(e) => handleChange(e)}
            />
          )}
        </TableCellFixedWidth>
      )}
      <TableGroupSearchToggle search={search} setOpen={setOpen} open={open} />
      {columns.map((column, i) => (
        <TableCell
          lang={UILanguage}
          align={column?.align}
          sx={{
            width: column.width,
            paddingLeft: i === 0 && disableSelectItems ? "26px" : "5px",
            paddingRight: "5px",
            maxWidth: column.maxWidth,
            ...column?.headerSx,
          }}
          key={column.displayName + i.toString()}
        >
          {t(column.displayName)}
        </TableCell>
      ))}
    </TableRow>
  );
};
